import { css } from '@emotion/react';
import { DataSourcesTypes } from '@frontend/api-data-sources';
import { useTranslation } from '@frontend/i18n';
import { Button, Text } from '@frontend/design-system';

export const ServiceProviderSourceInfo = ({
  sourceId,
  integrations,
  shouldMapToExternalProviderId,
  openModal,
}: {
  sourceId: string | undefined;
  integrations: DataSourcesTypes.DataSource[] | undefined;
  shouldMapToExternalProviderId: boolean | undefined;
  openModal: () => void;
}) => {
  const { t } = useTranslation('schedule');

  return (
    <>
      {sourceId ? (
        integrations?.map((source: any) => {
          return (
            source.SourceID === sourceId && (
              <section
                css={css`
                  display: inline;
                `}
                key={sourceId}
              >
                <Text>{source.SourceName}</Text>
                <Text color='light'>{source.PracticeManagementSystem}</Text>
              </section>
            )
          );
        })
      ) : (
        <div css={{ display: 'flex', alignItems: 'center' }}>
          <Text>{t('Weave')}</Text>
          {shouldMapToExternalProviderId && (
            <Button iconName='alert-invert' size='large' variant='secondary' onClick={openModal} destructive />
          )}
        </div>
      )}
    </>
  );
};
